import { render, staticRenderFns } from "./PropertiesSection.vue?vue&type=template&id=00ab1940&scoped=true"
import script from "./PropertiesSection.vue?vue&type=script&lang=js"
export * from "./PropertiesSection.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSection.vue?vue&type=style&index=0&id=00ab1940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab1940",
  null
  
)

export default component.exports